import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.find";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import ApiService from '../../../services/apiService';
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { EventBus } from '../../../services/eventbus.js';
import { isCopyToClipboardSupported, copyToClipboard } from '../../../utils/vuex';
import unsavedMixin from '../../../components/core/unsavedMixin';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
export default {
  name: 'ViewNiotaClassicDeviceTypesDeviceTypesDetails',
  mixins: [unsavedMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      deviceTypeId: null,
      deviceTypeData: null,
      canBeEdited: false,
      editedItem: null,
      formDialog: false,
      tabItem: 'details',
      healthStateConfig: {},
      healthStateConfigRegistryId: null,
      originalStateConfig: {},
      healthStateFormValid: false,
      linkedDeviceTypes: null,
      linkedVirtualDevices: null,
      tenantId: null,
      dialogSyncHealthStateOpen: false,
      linkedVirtualDevicesIds: []
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), mapGetters({
    isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
  })), {}, {
    isDeviceDriverFallbakActive: function isDeviceDriverFallbakActive() {
      return this.isFeatureFlagEnabled('env_dispatcher_devicetype_fallback');
    },
    detailsLoaded: function detailsLoaded() {
      return !this.deviceTypeData;
    },
    isIotHubManager: function isIotHubManager() {
      return this.permissions['IotHub.manage'];
    },
    showCopyButton: function showCopyButton() {
      return isCopyToClipboardSupported && this.permissions['super.system.manage'];
    },
    healthCareButtons: function healthCareButtons() {
      var applyButton = {
        icon: 'fa-sync',
        title: this.$i18n_t('Common.syncToVirtualDevices'),
        type: 'button',
        action: 'applied',
        valid: !this.formIsDirty,
        tooltip: this.formIsDirty ? this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.unsavedChanges') : ''
      };
      var arrayButtons = [{
        icon: 'fas fa-save',
        title: this.$i18n_t('Common.save'),
        type: 'button',
        action: 'submitted',
        valid: this.isIotHubManager ? this.healthStateFormValid : false
      }];
      arrayButtons.unshift(applyButton);
      return arrayButtons;
    },
    cardButtons: function cardButtons() {
      return [].concat(_toConsumableArray(this.canBeEdited ? [{
        icon: 'fal fa-edit',
        title: this.$i18n_t('Common.edit'),
        type: 'button',
        action: 'edit',
        valid: this.isIotHubManager
      }] : []), _toConsumableArray(this.showCopyButton ? [{
        title: this.$i18n_t('Common.copy'),
        icon: 'fal fa-clipboard',
        type: 'button',
        action: 'copy',
        valid: this.isIotHubManager
      }] : []), [{
        icon: 'fal fa-times',
        type: 'button',
        color: 'danger',
        action: 'cancel'
      }]);
    },
    virtualDeviceSearchTypes: function virtualDeviceSearchTypes() {
      return [{
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.title'),
        param: 'title'
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.keyValue'),
        param: 'keyValue'
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props')['bridge.type'],
        param: 'bridge.type',
        items: []
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.deviceId'),
        param: 'deviceId'
      }, {
        text: this.$i18n_t('Common.id'),
        param: 'id'
      }];
    }
  }),
  watch: {
    $route: function $route() {
      // the component is not reloaded/re-mounted if the id in the route changes
      // so perform the setup again for a different route; i.e. swap out the displayed details on-the-fly
      this.loadDeviceTypeDetails();
    },
    healthStateConfig: {
      handler: function handler() {
        this.formIsDirty = !isEqual(this.originalStateConfig, this.healthStateConfig);
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.loadDeviceTypeDetails();
    ApiService.getBridgeTypes().then(function (bridgeTypes) {
      (_this.virtualDeviceSearchTypes.find(function (item) {
        return item.param === 'bridge.type';
      }) || {}).items = bridgeTypes.filter(function (bridge) {
        // this bridge-type must have a create-functionality
        // otherwise it should have a read to get 1 single existing device as import
        if (get(bridge, 'manifest.functionScope.extension.devices.create') || get(bridge, 'manifest.functionScope.extension.devices.read')) {
          return true;
        }

        return false;
      }).map(function (bridge) {
        return bridge.type.replace(/^bridge-/gi, '');
      });
    }).catch(function (error) {
      console.error(error);
    });
  },
  methods: {
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
      // If the form is dirty and the user did not confirm leave,
      // prevent losing unsaved changes by canceling navigation
      if (this.formIsDirty) {
        this.unsavePromptNextPersist = next;
        this.unsavedPrompt = true;
      } else {
        if (this.$refs.parserWrapper) {
          this.$refs.parserWrapper.beforeRouteLeave(to, from, next);
        } else {
          next();
        }
      }
    },
    beforeWindowUnload: function beforeWindowUnload(e) {
      if (this.formIsDirty) {
        // Cancel the event
        e.preventDefault(); // Chrome requires returnValue to be set

        e.returnValue = ''; // eslint-disable-next-line no-empty-function

        this.unsavePromptNextPersist = function () {};

        this.unsavedPrompt = true;
      } else {
        if (this.$refs.parserWrapper) {
          this.$refs.parserWrapper.beforeWindowUnload(e);
        }
      }
    },
    breadCrumbsPath: function breadCrumbsPath() {
      if (get(this, 'deviceTypeData.account.name')) {
        return [this.permissions['all.manage'] ? {
          text: this.deviceTypeData.account.name,
          to: "/account-mgmt/".concat(this.deviceTypeData.account.id)
        } : this.deviceTypeData.account.name, this.deviceTypeData.title];
      }

      return [];
    },
    loadDeviceTypeDetails: function () {
      var _loadDeviceTypeDetails = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var linkedDeviceTypes, linkedVirtualDevices, devices, scopes;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.deviceTypeId = this.$route.params.deviceTypeId;
                Promise.all([ApiService.virtualDeviceGetDeviceTypeHealthConfig(this.deviceTypeId), NiotaClassicApiService.deviceTypeGetDetails(this.deviceTypeId)]).then(function (res) {
                  _this2.healthStateConfig = res[0].value || {};
                  _this2.originalStateConfig = cloneDeep(_this2.healthStateConfig);
                  _this2.formIsDirty = false;
                  _this2.healthStateConfigRegistryId = res[0].id;
                  var details = res[1].data;
                  _this2.deviceTypeData = details.devicetype;
                  _this2.canBeEdited = details.permission;

                  if (_this2.$route.query.edit !== undefined) {
                    _this2.handleEditDeviceType(); // remove query param


                    _this2.$router.replace(_this2.$route.path);
                  }

                  EventBus.$emit('update-breadcrumbs');
                }).catch(function (error) {
                  _this2.healthStateConfig = {};
                  _this2.originalStateConfig = cloneDeep(_this2.healthStateConfig);
                  _this2.healthStateConfigRegistryId = null;
                  _this2.deviceTypeData = null;

                  _this2.$snack(get(error, 'response.data.err') || _this2.$i18n_t('NiotaClassic.DeviceTypes.snacks.fetchDetailsFailed'), 'error');
                });
                _context.next = 4;
                return NiotaClassicApiService.getDeviceTypeDevices(this.deviceTypeId, '', 1, 1);

              case 4:
                linkedDeviceTypes = _context.sent;
                _context.next = 7;
                return ApiService.virtualDeviceFetch(this, null, [], null, null, null, 0, 1, [{
                  variable: 'deviceType',
                  search: this.deviceTypeId
                }], true);

              case 7:
                linkedVirtualDevices = _context.sent;
                devices = linkedVirtualDevices.virtualDevices || [];
                this.linkedDeviceTypes = linkedDeviceTypes.pagination.itemCount;
                this.linkedVirtualDevices = linkedVirtualDevices.totalCount;
                scopes = devices.reduce(function (acc, element) {
                  if (!acc.includes(element.tenantId)) {
                    acc.push(element.tenantId);
                  }

                  return acc;
                }, []);
                this.tenantId = scopes[0];
                this.linkedVirtualDevicesIds = devices.map(function (vd) {
                  return vd.id;
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadDeviceTypeDetails() {
        return _loadDeviceTypeDetails.apply(this, arguments);
      }

      return loadDeviceTypeDetails;
    }(),
    closeSyncHealthStateDialog: function closeSyncHealthStateDialog() {
      this.dialogSyncHealthStateOpen = false;
    },
    showDialogSyncHealthState: function showDialogSyncHealthState() {
      this.dialogSyncHealthStateOpen = true;
    },
    openForm: function openForm() {
      this.formDialog = true;
    },
    closeForm: function closeForm() {
      this.formDialog = false;
    },
    updateItem: function updateItem(item) {
      if (this.editedItem !== null) {
        this.deviceTypeData = cloneDeep(item);
      }
    },
    persistHealthStateConfig: function persistHealthStateConfig() {
      var _this3 = this;

      var value = this.healthStateConfig;
      var id = this.healthStateConfigRegistryId;
      ApiService.virtualDeviceUpdateDeviceTypeHealthConfig(this, this.deviceTypeId, value, id).then(function (res) {
        _this3.healthStateConfig = res.value;
        _this3.healthStateConfigRegistryId = res.id;
        _this3.originalStateConfig = cloneDeep(_this3.healthStateConfig);
        _this3.formIsDirty = false;

        _this3.$snack(_this3.$i18n_t('NiotaClassic.DeviceTypes.form.deviceHealth.saveSuccess'), 'success');
      }).catch(function () {
        _this3.$snack(_this3.$i18n_t('NiotaClassic.DeviceTypes.form.deviceHealth.saveError'), 'error');
      });
    },
    handleCopyDeviceType: function handleCopyDeviceType() {
      var _this4 = this;

      NiotaClassicApiService.deviceTypesGetCopy(this.deviceTypeId).then(function (res) {
        copyToClipboard(res.data.info);

        _this4.$snack(_this4.$i18n_t('NiotaClassic.DeviceTypes.snacks.copyClipboardSuccess'), 'success');
      }).catch(function () {
        _this4.$snack(_this4.$i18n_t('NiotaClassic.DeviceTypes.snacks.copyClipboardFailed'), 'error');
      });
    },
    handleEditDeviceType: function handleEditDeviceType() {
      this.editedItem = cloneDeep(this.deviceTypeData);
      this.openForm();
    },
    getDeviceTypeImageUrl: function getDeviceTypeImageUrl(image) {
      if (/^http(?:s):\/\//i.test(image)) {
        return image;
      }

      return "".concat(process.env.VUE_APP_N1_API_PROTOCOL, "://").concat(process.env.VUE_APP_N1_API_HOST).concat(image);
    }
  }
};